import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class SharedService {

  state:Array<any> = [];
  bankName:Array<any> = [];
  state1: any[];

  constructor() { }

  // public setState(){
  //   this.state = [];
  //   this.state.push({key:'AN',stateName:'Andaman and Nicobar Islands'});
  //   this.state.push({key:'AP',stateName:'Andhra Pradesh'});
  //   this.state.push({key:'AR',stateName:'Arunachal Pradesh'});
  //   this.state.push({key:'AS',stateName:'Assam'});
  //   this.state.push({key:'BR',stateName:'Bihar'});
  //   this.state.push({key:'CH',stateName:'Chandigarh'});
  //   this.state.push({key:'CT',stateName:'Chhattisgarh'});
  //   this.state.push({key:'DN',stateName:'Dadra and Nagar Haveli'});
  //   this.state.push({key:'DD',stateName:'Daman and Diu'});
  //   this.state.push({key:'DL',stateName:'Delhi'});
  //   this.state.push({key:'GA',stateName:'Goa'});
  //   this.state.push({key:'GJ',stateName:'Gujarat'});
  //   this.state.push({key:'HR',stateName:'Haryana'});
  //   this.state.push({key:'HP',stateName:'Himachal Pradesh'});
  //   this.state.push({key:'JK',stateName:'Jammu and Kashmir'});
  //   this.state.push({key:'JH',stateName:'Jharkhand'});
  //   this.state.push({key:'KA',stateName:'Karnataka'});
  //   this.state.push({key:'KL',stateName:'Kerala'});
  //   this.state.push({key:'LD',stateName:'Lakshadweep'});
  //   this.state.push({key:'MP',stateName:'Madhya Pradesh'});
  //   this.state.push({key:'MH',stateName:'Maharashtra'});
  //   this.state.push({key:'MN',stateName:'Manipur'});
  //   this.state.push({key:'ML',stateName:'Meghalaya'});
  //   this.state.push({key:'MZ',stateName:'Mizoram'});
  //   this.state.push({key:'NL',stateName:'Nagaland'});
  //   this.state.push({key:'OR',stateName:'Odisha'});
  //   this.state.push({key:'PY',stateName:'Puducherry'});
  //   this.state.push({key:'PB',stateName:'Punjab'});
  //   this.state.push({key:'RJ',stateName:'Rajasthan'});
  //   this.state.push({key:'SK',stateName:'Sikkim'});
  //   this.state.push({key:'TN',stateName:'Tamil Nadu'});
  //   this.state.push({key:'TG',stateName:'Telangana'});
  //   this.state.push({key:'TR',stateName:'Tripura'});
  //   this.state.push({key:'UT',stateName:'Uttarakhand'});
  //   this.state1.push({key:'UP',stateName:'Uttar Pradesh'});
  //   this.state.push({key:'WB',stateName:'West Bengal'});
  //   return this.state;
  // }
  public setState(){
    this.state = [];
    this.state.push({key:'AN',stateName:'ANDMAN AND NICOBAR ISLANDS'});
    this.state.push({key:'AP',stateName:'ANDHRA PRADESH'});
    this.state.push({key:'AR',stateName:'ARUNACHAL PRADESH'});
    this.state.push({key:'AS',stateName:'ASSAM'});
    this.state.push({key:'BR',stateName:'BIHAR'});
    this.state.push({key:'CH',stateName:'CHANDIGARH'});
    this.state.push({key:'CT',stateName:'CHHATTISGARH'});
    this.state.push({key:'DN',stateName:'DADRA AND NAGAR HAVELI'});
    this.state.push({key:'DD',stateName:'DAMAN AND DIU'});
    this.state.push({key:'DL',stateName:'DELHI'});
    this.state.push({key:'GA',stateName:'GOA'});
    this.state.push({key:'GJ',stateName:'GUJARAT'});
    this.state.push({key:'HR',stateName:'HARYANA'});
    this.state.push({key:'HP',stateName:'HIMACHAL PRADESH'});
    this.state.push({key:'JK',stateName:'JAMMU AND KASHMIR'});
    this.state.push({key:'JH',stateName:'JHARKHAND'});
    this.state.push({key:'KA',stateName:'KARNATAKA'});
    this.state.push({key:'KL',stateName:'KERALA'});
    this.state.push({key:'LD',stateName:'LAKSHADWEEP'});
    this.state.push({key:'MP',stateName:'MADHYA PRADESH'});
    this.state.push({key:'MH',stateName:'MAHARASHTRA'});
    this.state.push({key:'MN',stateName:'MANIPUR'});
    this.state.push({key:'ML',stateName:'MEGHALAYA'});
    this.state.push({key:'MZ',stateName:'MIZORAM'});
    this.state.push({key:'NL',stateName:'NAGALAND'});
    this.state.push({key:'OR',stateName:'ODISHA'});
    this.state.push({key:'PY',stateName:'PUDUCHERRY'});
    this.state.push({key:'PB',stateName:'PUNJAB'});
    this.state.push({key:'RJ',stateName:'RAJASTHAN'});
    this.state.push({key:'SK',stateName:'SIKKIM'});
    this.state.push({key:'TN',stateName:'TAMIL NADU'});
    this.state.push({key:'TG',stateName:'TELANGANA'});
    this.state.push({key:'TR',stateName:'TRIPURA'});
    this.state.push({key:'UT',stateName:'UTTARAKHAND'});
    this.state.push({key:'UP',stateName:'UTTAR PRADESH'});
    this.state.push({key:'WB',stateName:'WEST BENGAL'});
    return this.state;
  }
  public bankList(){
    this.bankName=[];
    this.bankName.push({key:1,value:'Andhra Bank',ifsc:'ANDB'});
    this.bankName.push({key:2,value:'Axis Bank',ifsc:'UTIB'});
    this.bankName.push({key:3,value:'Bank of Baroda',ifsc:'BARB_R'});
    this.bankName.push({key:4,value:'Bank of Maharashtra',ifsc:'MAHB'});
    this.bankName.push({key:5,value:'Canara Bank',ifsc:'CNRB'});
    this.bankName.push({key:6,value:'Central Bank of India',ifsc:'CBIN'});
    this.bankName.push({key:7,value:'City Union Bank',ifsc:'CIUB'});
    this.bankName.push({key:8,value:'Deutsche Bank',ifsc:'DEUT'});
    this.bankName.push({key:9,value:'Equitas Small Finance Bank',ifsc:'ESFB'});
    this.bankName.push({key:10,value:'Federal Bank',ifsc:'FDRL'});
    this.bankName.push({key:11,value:'HDFC Bank',ifsc:'HDFC'});
    this.bankName.push({key:12,value:'ICICI Bank',ifsc:'ICIC'});
    this.bankName.push({key:13,value:'IDBI Bank',ifsc:'IBKL'});
    this.bankName.push({key:14,value:'IDFC First Bank',ifsc:'IDFB'});
    this.bankName.push({key:15,value:'Indian Overseas Bank',ifsc:'IOBA'});
    this.bankName.push({key:16,value:'IndusInd Bank',ifsc:'INDB'});
    this.bankName.push({key:17,value:'Kotak Mahindra Bank',ifsc:'KKBK'});
    this.bankName.push({key:18,value:'Karnataka Bank LTD',ifsc:'KARB'});
    this.bankName.push({key:19,value:'Oriental Bank of Commerce',ifsc:'ORBC'});
    this.bankName.push({key:20,value:'Paytm Payments Bank',ifsc:'PYTM'});
    this.bankName.push({key:21,value:'Punjab National Bank',ifsc:'PUNB_R'});
    this.bankName.push({key:22,value:'RBL Bank',ifsc:'RATN'});
    this.bankName.push({key:23,value:'Standard Charted Bank',ifsc:'SCBL'});
    this.bankName.push({key:24,value:'State Bank of India',ifsc:'SBIN'});
    this.bankName.push({key:25,value:'Tamilnadu Mercantile Bank',ifsc:'TMBL'});
    this.bankName.push({key:26,value:'Ujjivan Small Finance Bank',ifsc:'USFB'});
    this.bankName.push({key:27,value:'Union Bank of India',ifsc:'UBIN'});
    this.bankName.push({key:28,value:'Cosmos Co-operative Bank',ifsc:'COSB'});
    this.bankName.push({key:29,value:'Dhanalaxmi Bank',ifsc:'DLXB'});
    this.bankName.push({key:30,value:'DBS Bank India LTD',ifsc:'DBSS'});
    this.bankName.push({key:31,value:'HSBC Bank',ifsc:'HSBC'});
    this.bankName.push({key:32,value:'Karur Vysya Bank',ifsc:'KVBL'});
    this.bankName.push({key:33,value:'Punjab and Sind Bank',ifsc:'PSIB'});
    this.bankName.push({key:34,value:'South Indian Bank',ifsc:'SIBL'});
    this.bankName.push({key:35,value:'Syndicate Bank',ifsc:'SYNB'});
    this.bankName.push({key:36,value:'Yes Bank',ifsc:'YESB'});
    
    return this.bankName;
  }
}
